module.exports = __webpack_public_path__ + "static/about-img8-c9ded98b41e55eb54d91a4df65397c74.png";